export const pageTransition = (pageIn, pageOut) =>
  new Promise(resolve => {
    pageIn.visible = true;

    if (pageOut) {
      pageOut.visible = false;
    }

    resolve();
  });
